<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/MyTeam/components/Details'

    export default {
        components: {
            Grid,
        }
    }
</script>